/**
 * PreviewFrameHost — renders the live-app preview body.
 *
 * Previously this was a BlockHost mount of `blocks-v2/studio/preview-frame/*`
 * (PR #119, Phase 3 Step 3.8b) which surfaced a floating top-right Web/Expo
 * toggle on top of every preview. The toggle's container-atom rendering did
 * not match the rest of the studio chrome and the overlay interfered with
 * editing, so the scaffold is dropped. If a target-picker is needed later
 * it should live in the top-bar, not as a canvas overlay.
 *
 * previewTarget state is preserved in the store (currently always 'web') so
 * a future target-picker can re-use it without a slice migration.
 */
import { BuildModeCanvas } from './ide-v2/components/build-mode-canvas'

interface PreviewFrameHostProps {
  routeSwitcherPortalElement?: HTMLElement | null
  onEditPage?: (pageId: string) => void
}

export function PreviewFrameHost({
  routeSwitcherPortalElement,
  onEditPage,
}: PreviewFrameHostProps) {
  return (
    <div className="relative flex h-full min-h-0 flex-col overflow-hidden">
      <BuildModeCanvas
        routeSwitcherPortalElement={routeSwitcherPortalElement}
        onEditPage={onEditPage}
      />
    </div>
  )
}
